const productTypeToReviewTypeMap = {
  APP: 'APP',
  THEME: 'THEME',
  MODULE: 'MODULE',
  AGENT: 'AGENT',
  SOLUTIONS_PARTNER_PROFILE: 'PROFILE'
};
export function getReviewTypeFromProductType(productType) {
  // TODO: Remove the if statement when we have a review type for workflow templates
  if (productType === 'WORKFLOW_TEMPLATE') {
    return 'APP';
  }
  return productTypeToReviewTypeMap[productType];
}